import { useContext } from "react";
import { DOMAIN, PERMISSION, useHasCapabilityBool } from "@/hooks/useCapabilities";
import { useFlags, useFlagsLoaded } from "@/hooks/useFeatureFlags";
import { resolveAllowedDefaultTab, sectionGroupKey } from "@/lib/defaultTab";
import { AuthorizationContext } from "@/providers/AuthorizationProvider";
import { Navigate, useLocation } from "react-router-dom";

export default function MembershipIndexPage() {
  const location = useLocation();
  const flags = useFlags();
  const flagsLoaded = useFlagsLoaded();
  const { loaded: capabilitiesLoaded } = useContext(AuthorizationContext);
  const base = location.pathname.replace(/\/$/, "");
  const group = sectionGroupKey(location.pathname);
  const showProspectProgramTab = flagsLoaded && flags["backoffice-prospect-program-tab"] !== true;

  const canViewPersonMembership = useHasCapabilityBool({
    domain: DOMAIN.PEOPLE,
    permission: PERMISSION.viewPersonMembership
  });
  const canManageApplications = useHasCapabilityBool({
    domain: DOMAIN.PEOPLE,
    permission: PERMISSION.manageApplications
  });

  const allowedTabs = [
    canViewPersonMembership && "overview",
    canViewPersonMembership && "path-to-membership",
    canViewPersonMembership && showProspectProgramTab && "prospect-program",
    canManageApplications && "applications",
    "section",
    "committees"
  ].filter((slug): slug is string => Boolean(slug));
  const firstTab = allowedTabs[0] ?? "section";
  const tab =
    flags["backoffice-navigation-preferences"] === true
      ? resolveAllowedDefaultTab(group ?? "", allowedTabs, firstTab)
      : firstTab;

  if (!flagsLoaded || !capabilitiesLoaded) {
    return null;
  }

  return <Navigate to={`${base}/${tab}`} replace />;
}
